import { useContextFallback } from '@prenuvo/halo';

import { UserContext } from './user.context';

export const useUser = () => useContextFallback(UserContext);
